<template>
  <div class="home">
    <section class="hero">
      <div class="container">
        <h1>杰出服务 创新未来</h1>
        <p>为您的企业提供最优质的解决方案</p>
        <router-link to="/contact" class="cta-button">立即咨询</router-link>
      </div>
    </section>

    <section class="features">
      <div class="container">
        <h2>我们的优势</h2>
        <div class="feature-grid">
          <div class="feature-card">
            <div class="icon">🚀</div>
            <h3>高效服务</h3>
            <p>快速响应客户需求，提供专业解决方案</p>
          </div>
          <div class="feature-card">
            <div class="icon">💡</div>
            <h3>创新技术</h3>
            <p>持续创新，引领行业发展</p>
          </div>
          <div class="feature-card">
            <div class="icon">🤝</div>
            <h3>优质团队</h3>
            <p>专业的技术团队，为您保驾护航</p>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<style scoped>
.hero {
  height: 90vh;
  display: flex;
  align-items: center;
  background-image: url('../../public/images/hero-home.jpg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  color: white;
  text-align: center;
  margin-top: -70px;
  padding-top: 140px;
  position: relative;
}

.hero::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1;
}

.hero .container {
  position: relative;
  z-index: 2;
}

.hero h1 {
  font-size: 3rem;
  margin-bottom: 1rem;
}

.hero p {
  font-size: 1.2rem;
  margin-bottom: 2rem;
}

.cta-button {
  display: inline-block;
  padding: 1rem 2rem;
  background: white;
  color: var(--primary-color);
  text-decoration: none;
  border-radius: 30px;
  font-weight: bold;
  transition: transform 0.3s;
  margin-top: 0rem;
}

.cta-button:hover {
  transform: translateY(-2px);
}

.hero-image {
  margin-top: 1rem;
  width: 100%;
  max-width: 400px;
  margin-left: auto;
  margin-right: auto;
}

.hero-image img {
  width: 100%;
  height: auto;
  border-radius: 10px;
  box-shadow: 0 0px 0px rgba(0,0,0,0.2);
}

.features {
  padding: 4rem 0;
}

.features h2 {
  text-align: center;
  margin-bottom: 3rem;
}

.feature-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
}

.feature-card {
  background: white;
  padding: 2rem;
  border-radius: 10px;
  text-align: center;
  transition: transform 0.3s;
  box-shadow: 0 5px 15px rgba(0,0,0,0.1);
}

.feature-card:hover {
  transform: translateY(-5px);
}

.icon {
  font-size: 2.5rem;
  margin-bottom: 1rem;
}

.feature-card h3 {
  margin-bottom: 1rem;
  color: var(--primary-color);
}
</style>